import { useCallback } from "react";

function useDeleteHandler(mutation, listUrl) {
  return useCallback(
    ({ confirmId, isDeletedInSingleView }, onFail) => {
      mutation.mutate({ confirmId, isDeletedInSingleView, listUrl, onFail });
    },
    [mutation, listUrl]
  );
}

export default useDeleteHandler;
